<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import { mapGetters } from 'vuex'

/**
 * Starter component
 */
export default {
  page: {
    title: 'Kontak Kami',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      phaseOneShow: false,
    }
  },

  computed: {
    ...mapGetters({
      getAsset: 'asset/getAsset',
    }),
    title() {
      return this.$t('menuitems.contactUs.text')
    },
    showFacebook() {
      return this.getAsset('facebook', 'contactUs')
    },
    showInstagram() {
      return this.getAsset('instagram', 'contactUs')
    },
    showLinkedIn() {
      return this.getAsset('linkedIn', 'contactUs')
    },
    showYoutube() {
      return this.getAsset('youtube', 'contactUs')
    },
    showWhatsapp() {
      return this.getAsset('whatsapp', 'contactUs')
    },
    checkSocialMedia() {
      return !!(
        this.showFacebook ||
        this.showInstagram ||
        this.showLinkedIn ||
        this.showYoutube ||
        this.showWhatsapp
      )
    },
  },
}
</script>

<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" />
      <p class="mb-4">{{ $t('contactUs.subtitle') }}</p>
    </div>

    <div class="mc-contact">
      <h4 class="mc-contact__title">{{ $t('contactUs.title') }}</h4>
      <b-row class="mb-4">
        <b-col md="6" class="mb-2">
          <h5 class="mc-contact__subtitle">
            <i class="mc-fa icon-fill_pin"></i>
            {{ $t('contactUs.headOffice') }}
          </h5>
          <p>{{ getAsset('headOffice', 'contactUs') }}</p>
        </b-col>
        <b-col md="6" class="mb-2">
          <h5 class="mc-contact__subtitle">
            <i class="mc-fa icon-fill_pin"></i>
            {{ $t('contactUs.operationalOffice') }}
          </h5>
          <p>{{ getAsset('operationalOffice', 'contactUs') }}</p>
        </b-col>
        <b-col md="6" class="mb-2">
          <h5 class="mc-contact__subtitle">
            <i class="mc-fa icon-fill_phone"></i>
            {{ $t('contactUs.telephoneHeadOffice') }}
          </h5>
          <p>{{ getAsset('headOfficePhone', 'contactUs') }}</p>
        </b-col>
        <b-col md="6" class="mb-2">
          <h5 class="mc-contact__subtitle">
            <i class="mc-fa icon-fill_smartphone"></i>
            {{ $t('contactUs.telephoneOperationalOffice') }}
          </h5>
          <p>{{ getAsset('operationalHandphone', 'contactUs') }}</p>
        </b-col>
        <b-col md="6" class="mb-2">
          <h5 class="mc-contact__subtitle">
            <i class="mc-fa icon-fill_smartphone"></i>
            {{ $t('contactUs.handphoneHeadOffice') }}
          </h5>
          <p>{{ getAsset('headOfficeHandphone', 'contactUs') }}</p>
        </b-col>
      </b-row>
      <h4 class="mc-contact__title" v-if="checkSocialMedia">{{ $t('contactUs.socialMedia') }}</h4>
      <div class="mc-contact__sosmed mb-5">
        <a :href="showFacebook" target="_blank" :hidden="!showFacebook">
          <img src="@/assets/images/sosmed/fb.svg" alt />
        </a>
        <a :href="showInstagram" target="_blank" :hidden="!showInstagram">
          <img src="@/assets/images/sosmed/ig.svg" alt />
        </a>
        <a :href="showLinkedIn" target="_blank" :hidden="!showLinkedIn">
          <img src="@/assets/images/sosmed/ln.svg" alt />
        </a>
        <a :href="showYoutube" target="_blank" :hidden="!showYoutube">
          <img src="@/assets/images/sosmed/yt.svg" alt />
        </a>
        <a :href="showWhatsapp" target="_blank" :hidden="!showWhatsapp">
          <img src="@/assets/images/sosmed/wa.svg" alt />
        </a>
      </div>
    </div>
  </Layout>
</template>
